import {
  baseSectionClass,
  IVA_STATUS_MAPPING,
  IVARowStyles,
} from './constants';

export const ChatSummaryTable = ({ items_resolutions }) => {
  if (
    !items_resolutions ||
    !Array.isArray(items_resolutions) ||
    items_resolutions.length === 0
  )
    return null;

  return (
    <div className='tw-flex tw-items-center tw-w-full tw-rounded-b-2xl tw-bg-grey-100/50 tw-border tw-border-1 tw-border-solid tw-border-grey-300/70 !tw-border-x-0 !tw-border-b-0  tw-overflow-x-auto'>
      <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
        <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
          <thead className='tw-rounded-xl'>
            <tr className='tw-rounded-2xl'>
              <th
                title='Complaint Item'
                className='tw-p-3 tw-w-[25%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Complaint Item
              </th>
              <th
                title='Complaint Qty'
                className='tw-w-[19%] tw-whitespace-nowrap tw-p-3 tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Complaint Qty
              </th>
              <th
                title='Total Price'
                className='tw-py-3 tw-px-1 tw-whitespace-nowrap tw-w-[15%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Total Price
              </th>
              <th
                title='Final IVA Status'
                className='tw-py-3 tw-px-1 tw-w-[25%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-whitespace-nowrap tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Final Status
              </th>
              <th
                title='Resolution'
                className='tw-py-3 tw-px-1 tw-w-[25%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300 tw-text-center tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis'
              >
                Resolution
              </th>
              <th
                title='Resolution Amt'
                className='tw-py-3 tw-px-1 tw-whitespace-nowrap tw-w-[20%] tw-bg-blue-200 tw-text-grey-800 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Resolution Amt
              </th>
            </tr>
          </thead>
          <tbody className='tw-bg-white'>
            {items_resolutions.map((item, index) => {
              if (!item) return null;
              return (
                <tr
                  key={item.Name || index}
                  className={
                    index === items_resolutions.length - 1
                      ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                      : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                  }
                >
                  <td
                    title={item.Name}
                    className={`
    tw-py-4 tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-cursor-pointer tw-relative tw-group
    ${index === items_resolutions.length - 1 ? 'tw-rounded-bl-xl' : ''}
  `}
                  >
                    <span className='tw-leading-tight tw-overflow-hidden tw-text-ellipsis tw-line-clamp-2 tw-p-0'>
                      {item.Name}
                    </span>
                  </td>
                  <td className='tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[10px]'>
                    {item.quantity_requested == '0'
                      ? '-'
                      : `${item.quantity_requested}`}
                  </td>
                  <td className='tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[10px]'>
                    {item.price_str === '0' ? '-' : `₹${item.price_str}`}
                  </td>
                  <td className='tw-px-1 tw-py-2 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-snug'>
                    {item.final_status ? item.final_status : '-'}
                  </td>
                  <td className='tw-py-2 tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[10px] tw-leading-snug'>
                    <span className='tw-capitalize'>
                      {item.resolutions?.type
                        ? `${item.resolutions?.type} - `
                        : '-'}
                    </span>
                    {item.resolutions?.resolved_qty
                      ? `${item.resolutions?.resolved_qty} ${
                          Number(item.resolutions?.resolved_qty) > 1
                            ? 'items'
                            : 'item'
                        }`
                      : ''}
                  </td>
                  <td
                    className={
                      index === 2
                        ? 'tw-rounded-br-2xl tw-border-none tw-px-2 tw-py-1'
                        : 'tw-px-2 tw-py-1'
                    }
                  >
                    {Number(item.resolutions?.amount_str)
                      ? `₹${item.resolutions.amount_str}`
                      : '-'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const IVATable = ({
  data,
  iva_session_index,
  isLatestSession = false,
}) => {
  return (
    <div className={`${baseSectionClass}`}>
      <div className='tw-text-lg tw-font-medium tw-w-full tw-leading-none'>
        <div className='tw-flex tw-items-center tw-justify-between tw-p-4 tw-w-full'>
          <div className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem]'>
            IVA Resolution {iva_session_index}{' '}
            {isLatestSession ? '(Latest)' : ''}
          </div>
          {data[0]?.reason && (
            <div className='tw-flex tw-items-center tw-gap-2'>
              <span className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem]'>
                {data[0]?.status === IVA_STATUS_MAPPING.APPROVED
                  ? 'Approval'
                  : 'Rejection'}{' '}
                Reason:
              </span>
              <span
                className={`${
                  data[0]?.status === IVA_STATUS_MAPPING.APPROVED
                    ? 'tw-text-base-green'
                    : 'tw-text-red-500'
                }`}
              >
                {data[0].reason || 'N/A'}
              </span>
            </div>
          )}
        </div>
        <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
          <thead className='tw-rounded-xl'>
            <tr className='tw-rounded-xl'>
              <th className={IVARowStyles}>Complaint Item</th>
              <th className={`${IVARowStyles} tw-w-[17%]`}>Complaint Qty</th>
              <th className={`${IVARowStyles} tw-w-[17%]`}>Status</th>
              <th className='tw-p-3 tw-w-[17%] tw-bg-blue-200 tw-text-grey-800 tw-text-center'>
                Approved Qty
              </th>
            </tr>
          </thead>
          <tbody className='tw-bg-white'>
            {data?.length > 0 &&
              data.map((iva_item, idx) => {
                if (!iva_item) return null;
                return (
                  <tr
                    key={iva_item.name || idx}
                    className={
                      idx === data.length - 1
                        ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                        : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                    }
                  >
                    <td
                      title={iva_item.name}
                      className={`
            tw-p-4 tw-border-r tw-border-solid tw-overflow-hidden tw-text-ellipsis tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-whitespace-nowrap hover:tw-opacity-90 hover:tw-scale-[1.01] tw-transition-all tw-ease-in-out tw-duration-200 tw-cursor-pointer ${
              idx === data.length - 1 ? 'tw-rounded-bl-xl' : ''
            }
            `}
                    >
                      {iva_item.name}
                    </td>
                    <td className='tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[10px]'>
                      {iva_item.requested_qty}
                    </td>
                    <td className='tw-px-2 tw-py-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[10px]'>
                      {iva_item.status}
                    </td>
                    <td
                      className={`tw-px-2 tw-py-1 ${
                        idx === data.length - 1 ? 'tw-rounded-br-2xl' : ''
                      }`}
                    >
                      {iva_item.resolved_qty}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
